import { AxiosResponse } from "axios";
import { PaginationResponse, StatusResponse } from "../../types/type";
import Api from "../api";
import { LOGISTICS_MASTER, TIMESHEET_MASTER } from "../endpoint";
import { FormValues } from "../../types/assetTypes";

type FilterValue = {
 
    value: string[];
  };
  
  type Filters = {
    [key: string]: FilterValue;
  };





export const getListOfLogistics = async(page:number, rows:number,filter: Filters | undefined, searchTerm: string = ""):Promise<{
    status: StatusResponse, 
    data:FormValues[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page,
        offSet: page,
        filters: filter,
        searchTerm: searchTerm,
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: FormValues[],
            pagination: PaginationResponse
        //}> = await Api.get(`${LOGISTICS_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${LOGISTICS_MASTER}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Error in Get list of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getListOfTimesheet = async(page:number, rows:number,filter: Filters | undefined, searchTerm: string = ""):Promise<{
    status: StatusResponse, 
    data:FormValues[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,
        page: page,
        offSet: page,
        filters: filter,
        searchTerm: searchTerm,
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: FormValues[],
            pagination: PaginationResponse
        //}> = await Api.get(`${LOGISTICS_MASTER}?page=${page}&limit=${rows}`);
    }> = await Api.post(`${TIMESHEET_MASTER}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Error in Get list of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}


export const deleteLogisticsDetails = async (logisticsId:number) => {
    try{
        const response = await Api.delete(`${LOGISTICS_MASTER}/${logisticsId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of Logistics with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const createLogisticsData = async (payload: FormValues): Promise<{status:StatusResponse,data:any}>  => {
    try{
        const response:AxiosResponse<{status:StatusResponse,data:any}> = await Api.post(LOGISTICS_MASTER,payload);
        if(response.status === 200|| response.status == 201) {
            return response.data;
        }else{
            throw new Error(`Create Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const updateLogisticsData = async (payload:FormValues): Promise<{status:StatusResponse,data:any}> => {
    try{
        const response:AxiosResponse<{status:StatusResponse,data:any}> = await Api.put(LOGISTICS_MASTER,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Update Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getLogisticsByIdData = async (logisticsId:number): Promise<{
    status: StatusResponse, 
    data: FormValues
}> => {
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: FormValues,
    }> = await Api.get(`${LOGISTICS_MASTER}/${logisticsId}`);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get data by id of Asset with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}

